

import { Col, Row, Tooltip } from 'antd'
import React, { useEffect, useState } from 'react'
import { FaChevronRight, FaLongArrowAltRight } from "react-icons/fa";
import { holiday_mood } from '../../../utils/ImagePath';
import { Link } from 'react-router-dom'
import { getCategoriesList } from '../../../services/holiday/holidayServices';

const PackageCategorybyTheme = () => {

    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(null);
    const [packageData, setPackageData] = useState({});


    const fetchPackageData = () => {
        setLoading(true);
        getCategoriesList()
            .then((response) => {
                setPackageData(response?.data)
            })
            .catch((error) => {
                setError(error.message || "An error occurred while fetching package data.");
            })
            .finally(() => {
                setLoading(false);
            });
    };

    useEffect(() => {
        fetchPackageData();
    }, [])


    return (
        <>
            <div className='Vacation-area holiday-home ptb-70'>
                <div className="container">
                    <div className="section-title"><div>
                        <h3>Holidays by Theme </h3>
                        <span className="top-title">Enjoy hassle free bookings with <b>SuperbWorldTrip.com</b></span></div>
                        <Link to="/holiday-packages-by-theme" aria-label="Book Now">View All Themes</Link>
                    </div>

                    <Row gutter={20} className="g-lg-4 gy-5 mb-70 text-center flex-row-reverse">

                        <Col md={8} xs={24}>
                            <div className='destination_back'>
                                <img loading="lazy" src={holiday_mood} alt="" className='destination-img' />
                                <div className='destination_back_content'>
                                    <h3>Holidays by Theme </h3>
                                    <h2>Stay & Enjoy</h2>
                                    <p>Enjoy hassle free bookings with <b>SuperbWorldTrip.com</b></p>
                                    <Link to="/holiday-packages-by-theme" aria-label="Book Now">See more <FaChevronRight /></Link>
                                </div>
                            </div>
                        </Col>

                        <Col md={16} xs={24}>
                            <Row gutter={20}>
                                {packageData?.length > 0 ? (
                                    packageData.slice(0, 6)?.map((pkg, index) => (
                                        <Col key={index} lg={12} md={12} xs={24}>
                                            <div className="Vacation-cntr mb-2">
                                                <img loading="lazy" src={pkg?.thumbnail_image_url !== null ? pkg?.thumbnail_image_url : pkg?.image_url} alt={pkg?.name} className='Vacation-img' height={'80px'} width={'110px'} />

                                                <div className="text-start">
                                                    <h3 className="tr-trip-title">
                                                        <Tooltip title={pkg?.name}><h4 className="package-title">{pkg?.name}</h4></Tooltip>
                                                    </h3>
                                                    <Link to={`/package/${pkg?.slug}`} aria-label="Explore Now" className="d-flex align-items-center gap-3">
                                                        Explore Now <FaLongArrowAltRight />
                                                    </Link>
                                                </div>
                                            </div>
                                        </Col>
                                    ))
                                ) : (
                                    <div>No packages available.</div>
                                )}
                            </Row>
                        </Col>

                    </Row>

                </div>
            </div>
        </>
    )
}

export default PackageCategorybyTheme
